import Vue from 'vue'
import MyDialog from '@/apps/open/components/Dialog'

Vue.use(MyDialog, { width: '500px', 'close-on-click-modal': false })
